export const PSEUDO_LOCALE_QA_LANGUAGE = "en-XA";
export const PSEUDO_LOCALE_STORAGE_KEY = "6529-safe-app.pseudoLocale";

const interpolationPattern = /\{\{\s*[\w.-]+\s*\}\}/gu;
const pseudoAccentMap = new Map<string, string>([
  ["A", "Å"],
  ["B", "Ɓ"],
  ["C", "Ç"],
  ["D", "Ð"],
  ["E", "É"],
  ["F", "Ƒ"],
  ["G", "Ĝ"],
  ["H", "Ĥ"],
  ["I", "Í"],
  ["J", "Ĵ"],
  ["K", "Ķ"],
  ["L", "Ļ"],
  ["M", "Ṁ"],
  ["N", "Ñ"],
  ["O", "Ó"],
  ["P", "Þ"],
  ["Q", "Ɋ"],
  ["R", "Ŕ"],
  ["S", "Ş"],
  ["T", "Ţ"],
  ["U", "Ú"],
  ["V", "Ṽ"],
  ["W", "Ŵ"],
  ["X", "Ẋ"],
  ["Y", "Ý"],
  ["Z", "Ž"],
  ["a", "å"],
  ["b", "ƀ"],
  ["c", "ç"],
  ["d", "ð"],
  ["e", "è"],
  ["f", "ƒ"],
  ["g", "ĝ"],
  ["h", "ĥ"],
  ["i", "í"],
  ["j", "ĵ"],
  ["k", "ķ"],
  ["l", "ļ"],
  ["m", "ṁ"],
  ["n", "ñ"],
  ["o", "ó"],
  ["p", "þ"],
  ["q", "ɋ"],
  ["r", "ŕ"],
  ["s", "ş"],
  ["t", "ţ"],
  ["u", "ú"],
  ["v", "ṽ"],
  ["w", "ŵ"],
  ["x", "ẋ"],
  ["y", "ý"],
  ["z", "ž"]
]);

function pseudoAccentText(value: string): string {
  return [...value].map((character) => pseudoAccentMap.get(character) ?? character).join("");
}

export function pseudoLocalize(value: string): string {
  const segments: string[] = [];
  let cursor = 0;

  for (const match of value.matchAll(interpolationPattern)) {
    const matchIndex = match.index ?? 0;
    if (matchIndex > cursor) {
      segments.push(pseudoAccentText(value.slice(cursor, matchIndex)));
    }
    segments.push(match[0]);
    cursor = matchIndex + match[0].length;
  }

  if (cursor < value.length) {
    segments.push(pseudoAccentText(value.slice(cursor)));
  }

  return `[!! ${segments.join("")} !!]`;
}

export function createPseudoLocaleCatalog<T>(catalog: T): T {
  if (typeof catalog === "string") {
    return pseudoLocalize(catalog) as T;
  }

  if (Array.isArray(catalog)) {
    return catalog.map((entry) => createPseudoLocaleCatalog(entry)) as T;
  }

  if (catalog && typeof catalog === "object") {
    return Object.fromEntries(
      Object.entries(catalog).map(([key, value]) => [key, createPseudoLocaleCatalog(value)])
    ) as T;
  }

  return catalog;
}
